<template>
  <div
    class="flex justify-center items-center w-10 h-10 rounded-full hover:bg-gray-04 focus:bg-gray-12 active:bg-gray-10 cursor-pointer"
    @click="$emit('click')"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  emits: ['click'],
  props: {},
};
</script>

<style scoped></style>
